<template>
  <v-form ref="form" @submit.prevent="$emit('submit', value)">
    <v-row class="d-flex justify-center mt-3">
      <v-col cols="4">
        <v-text-field
          label="Nome da Turma"
          v-model="value.nomeDaTurma"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="value.anoSerie"
          label="Ano/Série"
          item-text="nome"
          item-value="id"
          outlined
          dense
          :items="lists.listAnoSeries"
        ></v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="value.turno"
          label="Turno"
          item-text="descricao"
          item-value="id"
          outlined
          dense
          :items="lists.listTurnos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-model="value.escola"
          label="Escola"
          item-text="local"
          item-value="id"
          outlined
          dense
          :items="lists.filteredListEscolas"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-col cols="12">
        <sca-submit-button />
        <sca-tooltip
          :text="'Limpar'"
          :icon="'mdi-eraser'"
          @click="resetForm()"
        ></sca-tooltip>
      </v-col>
    </div>
  </v-form>
</template>
<script>
export default {
  name: 'FiltrosDeListagemArticuladorMunicipal',
  props: {
    value: {
      type: Object,
      default: () => ({
        nomeDaTurma: null,
        anoSerie: null,
        turno: null,
        municipio: null,
        escola: null
      })
    },
    lists: {
      type: Object,
      default: () => ({
        listAnoSeries: [],
        listTurnos: [],
        listMunicipios: [],
        filteredListMunicipios: [],
        filteredListEscolas: []
      })
    }
  },
  watch: {
    value(v) {
      this.$emit('input', v);
    }
  },
  methods: {
    resetForm() {
      this.$resetForm();
      this.lists.listAcompanhamentoDeTurmas = [];
      this.lists.filteredListMunicipios = this.lists.listMunicipios;
      this.lists.filteredListEscolas = this.lists.listEscolas;
    },
  }
}
</script>